export const environment = {
  production: false,
  BaseApiUrl: 'https://api-test-mrsms.fastcode.it/api',
  useHash: false,
  adminUsername:['Administrator']
};
